import handIcon from '~/assets/icons/hand.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Divider } from '~/components/ui/Divider';
import { ImgIcon } from '~/components/ui/ImgIcon';
import { Text } from '~/components/ui/Text';
import { rage } from '~/rage';
import { Head } from '../../components/Head';
import { Reward } from '../../components/Reward';
import {
	StyledButton,
	StyledContainer,
	StyledNote,
	StyledText,
} from './BetaRewards.styled';

const BETA_REWARDS_TEXT = [
	'Приветствуем тебя, на ОБТ CCDPlanet V!',
	'Мы очень благодарны за твою помощь на тестировании сервера в режиме ЗБТ, и в знак нашей благодарности хотим вручить тебе подарок, который поможет тебе на старте.',
	'С уважением, администрация CCDPlanet.',
].join('\n\n');

const BetaRewards = () => {
	const handleClaim = () => {
		playSound(Sound.ClickButton);
		rage.betaRewards
			.claimReward()
			.catch((err) => rage.notifications.showException(err));
	};

	return (
		<StyledContainer>
			<Head />
			<Divider $direction="H" style={{ opacity: 0.1 }} />
			<Reward />
			<StyledText>{BETA_REWARDS_TEXT}</StyledText>
			<Divider $direction="H" style={{ opacity: 0.1 }} />
			<StyledButton
				onClick={handleClaim}
				onMouseEnter={() => playSound(Sound.LinkCursor)}
			>
				<ImgIcon icon={handIcon} width={20} height={20} />
				<Text>Получить награду</Text>
			</StyledButton>
			<Divider $direction="H" style={{ opacity: 0.1 }} />
			<StyledNote>
				*Награда будет автоматически добавлена на ваш текущий аккаунт
			</StyledNote>
		</StyledContainer>
	);
};

export { BetaRewards };
